import type { EstadoDiarioRespuesta } from '@tms/contratos';
import { api } from '../api';
import { ultimosDias } from './format';
import { useCarga, type Carga } from './hooks';

/** Estado diario de los 7 días que terminan en `hasta`, en una sola llamada (respuesta con `unidades` de todos los días). */
export function useEstadoDiarioSemana(hasta: string): Carga<EstadoDiarioRespuesta> & { dias: string[] } {
  const dias = ultimosDias(hasta, 7);
  const c = useCarga(() => api.estadoDiarioRango(dias[0], hasta), [hasta]);
  return { ...c, dias };
}
